import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Profile from "../screens/auth/Profile";
import Membership from "../screens/users/Membership";
import Rental from "../screens/users/Rental";
import SportsAcademy from "../screens/users/SportsAcademy";
import Leagues from "../screens/users/Leagues";
import Events from "../screens/users/Events";
import BarAndRestaurant from "../screens/users/BarAndRestaurant";
import AllFields from "../screens/auth/AllFields";
import NewsBlogs from "../screens/auth/NewsBlogs";
import SportsCategories from "../screens/auth/SportsCategories";
import EventsBookings from "../screens/auth/EventsBookings";
import Testimonials from "../screens/auth/Testimonials";
import AllRentalFields from "../components/User/RentalFields/AllRentalFields";
import RentalFieldDetails from "../components/User/RentalFields/RentalFieldDetails";
import BlogDetails from "../screens/users/BlogDetails";
import Requests from "../screens/auth/Requests";
import Clubworx from "../screens/users/Clubworx";
import AdminEvent from "../screens/auth/AdminEvent";
import ContactInfo from "../screens/auth/ContactInfo";
import ChatbotInquiries from "../screens/auth/ChatbotInquiries";
import AdminRental from "../screens/auth/AdminRental";
import AdminMembership from "../screens/auth/AdminMembership";
import AdminSportsAcademy from "../screens/auth/AdminSportsAcademy";
import BannerData from "../screens/auth/BannerData";
import ExtraContents from "../screens/auth/ExtraContents";
import CombinedContentManager from "../screens/auth/CombinedContentManager";
import AdminFaqs from "../screens/auth/AdminFaqs";
import Faqs from "../screens/users/Faqs";
import BarRestaurantsContents from "../screens/auth/BarRestaurantsContents";
import JobApplications from "../screens/auth/JobApplications";
import JobPosts from "../screens/auth/JobPosts";
import Career from "../screens/users/Career";
import EventPackages from "../screens/users/EventPackages";
import PartyRequest from "../screens/users/PartyRequest";
import AdminEventPackages from "../screens/auth/AdminEventPackages";
import AdminPartyRequests from "../screens/auth/AdminPartyRequests";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/bookings",
    component: <Booking />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  // {
  //   path: "/contents",
  //   component: <Contents />,
  // },
  {
    path: "/all-fields",
    component: <AllFields />,
  },
  {
    path: "/news-blogs",
    component: <NewsBlogs />,
  },
  {
    path: "/sports-categories",
    component: <SportsCategories />,
  },
  {
    path: "/events-bookings",
    component: <EventsBookings />,
  },
  {
    path: "/testimonials",
    component: <Testimonials />,
  },
  {
    path: "/inquiries",
    component: <Requests />,
  },
  {
    path: "/events",
    component: <AdminEvent />,
  },
  {
    path: "/contact-info",
    component: <ContactInfo />,
  },
  {
    path: "/rental-content",
    component: <AdminRental />,
  },
  {
    path: "/membership-content",
    component: <AdminMembership />,
  },
  {
    path: "/combined-home-contents",
    component: <CombinedContentManager />,
  },
  {
    path: "/sports-academy-content",
    component: <AdminSportsAcademy />,
  },
  {
    path: "/chat-bot-inquiries",
    component: <ChatbotInquiries />,
  },
  {
    path: "/all-page-banner-data",
    component: <BannerData />,
  },
  {
    path: "/extra-contents",
    component: <ExtraContents />,
  },
  {
    path: "/admin-faqs",
    component: <AdminFaqs />,
  },
  {
    path: "/bar-restaurants-contents",
    component: <BarRestaurantsContents />,
  },
  {
    path: "/job-applications",
    component: <JobApplications />,
  },
  {
    path: "/job-posts",
    component: <JobPosts />,
  },
  {
    path: "/admin-event-packages",
    component: <AdminEventPackages />,
  },
  {
    path: "/admin-party-requests",
    component: <AdminPartyRequests />,
  },
];

export const nonAuthRoutes = [
  {
    path: "/admin-login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/rental",
    component: <Rental />,
  },
  {
    path: "/membership",
    component: <Membership />,
  },
  {
    path: "/sports-academy",
    component: <SportsAcademy />,
  },
  {
    path: "/leagues",
    component: <Leagues />,
  },
  {
    path: "/events",
    component: <Events />,
  },
  {
    path: "/bar-and-restaurant",
    component: <BarAndRestaurant />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/our-bookings",
    component: <Clubworx />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/all-rental-fields",
    component: <AllRentalFields />,
  },
  {
    path: "/rental-field-details/:id",
    component: <RentalFieldDetails />,
  },
  {
    path: "/news-blog-details",
    component: <BlogDetails />,
  },
  {
    path: "/faqs",
    component: <Faqs />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/careers/:jobName",
    component: <Career />,
  },
  {
    path: "/event-packages",
    component: <EventPackages />,
  },
  {
    path: "/party-request",
    component: <PartyRequest />,
  },
];
